export default (data: string) => {
    return data.split('base64,')[1];
};
